<script>
  import resources from './resources'

  export default {
    name: 'registration-me',
    mixins: [resources]
  }
</script>

<template lang="pug">
  page(title="Meu Cadastro", icon="")
    .col-xs-12.content
        .container-fluid
          .row
            .col-xs-12
              .col-sm-10
                h4 PERFIL PROFISSIONAL
                .row
                  .form-group.col-xs-12.col-sm-3.margin-bottom
                    f-select-entities(label="Entdidade de Classe",
                     name="entity_id",
                     v-model="registration.entity_id",
                     :get-all="true",
                     :errors="errors['entity_id']",
                     :disabled="true")

                  .form-group.col-xs-12.col-sm-3.margin-bottom
                    f-text(label="Número de Registro"
                    name="document",
                    v-model="registration.document",
                    :errors="errors['document']",
                    :disabled="true")

                  .form-group.col-xs-12.col-sm-3.margin-bottom
                    f-select-state(label="UF",
                     name="state",
                     v-model="registration.state",
                     :searchable="true",
                     :errors="errors['state']",
                     :disabled="true")

                  .form-group.col-xs-12.col-sm-3.margin-bottom
                    f-date(label="Data de Inscrição",
                    v-model="registration.record",
                    :errors="errors['record']")

                .form-group
                  .row
                    .form-group.col-xs-12.col-sm-3.margin-bottom
                      f-document(label="CPF"
                        name="country_register",
                        v-model="registration.country_register",
                        :errors="errors['country_register']")

                    .form-group.col-xs-12.col-sm-6.margin-bottom
                      f-text(label="Nome Completo"
                      name="name",
                      v-model="registration.name",
                      :errors="errors['registration.name']")

                    .form-group.col-xs-12.col-sm-3.margin-bottom
                      f-date(label="Data de Nascimento",
                      v-model="registration.birthdate",
                      :errors="errors['birthdate']")

                .row.border-bottom
                .form-group(style='margin-top:15px;')
                  .row
                    .col-xs-12.col-sm-12.margin-bottom
                      f-text(label="Perfil LinkedIn",
                       name="social",
                       v-model="registration.networks.linkedin",
                       :errors="errors['networks']",
                       placeholder='http://www.linkedin.com')

                      f-text(label="Currículo Lattes"
                        name="social",
                        v-model="registration.networks.lattes",
                        :errors="errors['networks']",
                        placeholder='http://lattes.cnpq.br')

                .row
                  .col-xs-12.col-sm-12
                    f-file-text(v-if="!registration.attachment.uuid", label="Anexar CRM"
                     v-model="registration.attachment",
                     name='attachment',
                     :errors="errors['attachment'] || errors['attachment.file'] || errors['attachment.mime']")

                .buttons-wrapper
                  button.btn.save.pull-right(@click.prevent="doSave()")
                      span.icon 
                      |  Salvar Alterações
</template>



// WEBPACK FOOTER //
// src/app/employee/record/registration/me.vue